import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import { IntlProvider, addLocaleData } from "react-intl";
import locale_en from "react-intl/locale-data/en";
import locale_es from "react-intl/locale-data/es";
import flat from "flat";
import { MuiThemeProvider } from "@material-ui/core";

import HomeScreen from "./general/HomeScreen";
import NewHomeScreen2 from "./general/NewHomeScreen2";

import AboutScreen from "./general/AboutScreen";
import ContactScreen from "./general/ContactScreen";
import TermsOfUseScreen from "./general/TermsOfUseScreen";
import PrivacyPolicyScreen from "./general/PrivacyPolicyScreen";
import PromoScreen from "./general/PromoScreen";

import DetailerPitchScreen from "./detailer/DetailerPitchScreen";
import DetailerSignUpScreen from "./detailer/DetailerSignUpScreen";
import DetailerPackages from "./detailer/DetailerPackages";

import * as routes from "../constants/routes";

import withAuthentication from "./withAuthentication";
import StripeConnectOnboardFinishScreen from "./dashboard/StripeConnectOnboardFinishScreen";
import Theme from "../theme";

import messages_en from "../translations/en.json";
import messages_es from "../translations/es.json";

// Flatten the messages because react-intl doesn't like JSON hierarchies
const messages = {
  en: flat(messages_en),
  es: flat(messages_es)
};

addLocaleData([...locale_en, ...locale_es]);

const language = navigator.language.split(/[-_]/)[0]; // language without region code

const App = () => (
  <IntlProvider
    defaultLocale="en"
    locale={language}
    messages={messages[language]}
  >
    <MuiThemeProvider theme={Theme}>
      <Router>
        <div>
          <Switch>
            <Route exact path={routes.HOME} component={() => <HomeScreen />} />
            <Route
              exact
              path={routes.NEW}
              component={() => <NewHomeScreen2 />}
            />

            <Route
              exact
              path={routes.ABOUT}
              component={() => <AboutScreen />}
            />
            <Route
              exact
              path={routes.CONTACT}
              component={() => <ContactScreen />}
            />
            <Route
              exact
              path={routes.TERMS_OF_USE}
              component={() => <TermsOfUseScreen />}
            />
            <Route
              exact
              path={routes.PRIVACY_POLICY}
              component={() => <PrivacyPolicyScreen />}
            />
            <Route
              exact
              path={routes.PROMO_HB}
              component={() => <PromoScreen />}
            />

            <Route
              exact
              path={routes.DETAILER_PITCH}
              component={() => <DetailerPitchScreen />}
            />
            <Redirect exact from={routes.DETAILER} to={routes.DETAILER_PITCH} />
            <Route
              exact
              path={routes.DETAILER_SIGNUP}
              component={() => <DetailerSignUpScreen />}
            />
            <Route
              exact
              path={routes.DETAILER_PACKAGES}
              component={() => <DetailerPackages />}
            />

            <Route
              exact
              path={routes.STRIPE_CONNECT_ONBOARD_FINISH}
              component={() => <StripeConnectOnboardFinishScreen />}
            />
          </Switch>
        </div>
      </Router>
    </MuiThemeProvider>
  </IntlProvider>
);

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/screens/App.js